import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getPatientAnalyses = asyncThunkWrapper({ 
  model: 'patientAnalyses', 
  action: 'getPatientAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/patient_flow/patient_analyses', { params });

    return response.data;
  } 
});
export const getPatientAnalysis = asyncThunkWrapper({ 
  model: 'patientAnalyses', 
  action: 'getPatientAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/patient_analyses/${id}`, { params });

    return { data: response.data, cable }
  } 
});
export const clearLocalPatientAnalyses = createAction('patientAnalyses/clearLocalPatientAnalyses');
export const clearLocalActivePatientAnalysis = createAction('patientAnalyses/clearLocalActivePatientAnalysis');